const style = {
  table: {
    border: `1px solid #666`
  },
  row: {
    ':not(:last-of-type)': {
      borderBottom: `1px solid #666`
    }
  },
  col: {
    ':not(:last-of-type)': {
      borderRight: `1px solid #666`
    }
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/Application/Main/style/ColorBlind/table.js